module.exports = __webpack_public_path__ + "img/extension-debauvoir.91f6472e.jpg";